export default __webpack_public_path__ + "static/media/pos-pro-1.db335f35.jpg";